import { AboutYourLoan } from "./aboutYourLoan";
import { ExistingLoanDetails } from "./indicativeRepaymentOptions";

export type LoanInfo = Pick<
  AboutYourLoan,
  | "accountNumber"
  | "sortCode"
  | "CRHTaken"
  | "CIRHTaken"
  | "fullTermExtensionTaken"
>;
export type LoanDetails = LoanInfo & ExistingLoanDetails;

export const defaultLoanDetails = (): LoanDetails => {
  return {
    accountNumber: "",
    sortCode: "",
    numberOfRepayments: 0,
    CRHTaken: 0,
    CIRHTaken: 0,
    fullTermExtensionTaken: false,
    remainingBalance: 0,
    monthlyRepaymentAmount: 0,
    totalRepaymentAmount: 0,
    interestRate: 0,
    finalRepaymentDate: new Date(),
  };
};

export const formatSortCode = (sortCode: string) =>
  sortCode.replace(/(\d{2})(\d{2})(\d{2})/, "$1-$2-$3");
